/**
 * Template slice (SCRUM-1952, RTK bundle 3) — the former switch reducer
 * templateReducer.js as createSlice. Behaviour-preserving: every case answers
 * the same legacy action type string (templateTypes.js) that templateAction.js
 * already dispatches, and returns the same state. The actions module is
 * unchanged, so no importer changes.
 * Characterised by tests/integration/reducers/contentReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  POST_TEMPLATE,
  GET_TEMPLATE,
  DELETE_TEMPLATE,
  UPDATE_TEMPLATE,
  GET_TEMPLATE_BY_DESIGN,
  SAVE_SETTINGS_REQUIRED,
  SAVE_SETTINGS_OPTIONAL,
} from "./templateTypes";

type TemplateState = {
  templates: any[];
  addTemplate: any;
  templates_by_design_site: any[];
  template_updated: any;
  settings_required: any[];
  settings_optional: any[];
};

const initialState: TemplateState = {
  templates: [],
  addTemplate: {},
  templates_by_design_site: [],
  template_updated: {},
  settings_required: [],
  settings_optional: [],
};

const templateSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(POST_TEMPLATE, (state, action: PayloadAction<TemplateState["addTemplate"], typeof POST_TEMPLATE>) => ({
        ...state,
        addTemplate: action.payload,
        templates: [...state.templates, action.payload],
      }))
      .addCase(GET_TEMPLATE, (state, action: PayloadAction<TemplateState["templates"], typeof GET_TEMPLATE>) => ({ ...state, templates: action.payload }))
      .addCase(DELETE_TEMPLATE, (state, action: PayloadAction<string, typeof DELETE_TEMPLATE>) => ({
        ...state,
        templates: state.templates.filter((template) => template._id !== action.payload),
      }))
      .addCase(UPDATE_TEMPLATE, (state, action: PayloadAction<TemplateState["template_updated"], typeof UPDATE_TEMPLATE>) => ({
        ...state,
        template_updated: action.payload,
      }))
      .addCase(SAVE_SETTINGS_REQUIRED, (state, action: PayloadAction<TemplateState["settings_required"], typeof SAVE_SETTINGS_REQUIRED>) => ({
        ...state,
        settings_required: action.payload,
      }))
      .addCase(SAVE_SETTINGS_OPTIONAL, (state, action: PayloadAction<TemplateState["settings_optional"], typeof SAVE_SETTINGS_OPTIONAL>) => ({
        ...state,
        settings_optional: action.payload,
      }))
      .addCase(GET_TEMPLATE_BY_DESIGN, (state, action: PayloadAction<TemplateState["templates_by_design_site"], typeof GET_TEMPLATE_BY_DESIGN>) => ({
        ...state,
        templates_by_design_site: action.payload,
      }));
  },
});

export default templateSlice.reducer;
